// extracted by css-extract-rspack-plugin
export default {"size4":"4px","size580":"580px","borderRadiusXSmall":"4px","dialogContainer":"genesis-base-dialog__dialogContainer___ziq1n","dialogBody":"genesis-base-dialog__dialogBody___XjNom"};